type SectionHeaderProps = {
  title?: string
}

export default function SectionHeader({ title = 'Connected Accounts' }: SectionHeaderProps) {
  return (
    <div className="flex h-11 min-h-11 items-center border-b border-brand-neutral-200 px-4 py-2">
      <p className="min-w-0 flex-1 text-sm font-semibold leading-5 text-brand-neutral-500">{title}</p>
    </div>
  )
}
